import { createFileRoute } from '@tanstack/react-router';
import { LegacyMessage } from '@/components/web-fe/legacy/legacy-ext-deprecation-message';

export const Route = createFileRoute('/app/add_content')({
  component: LegacyMessage,
});
